export var BackupZeroEtlSingleResourceTableMappingMode;
(function (BackupZeroEtlSingleResourceTableMappingMode) {
    BackupZeroEtlSingleResourceTableMappingMode["BACKUP_ZERO_ETL_SINGLE_RESOURCE_TABLE_MAPPING_MODE_DIRECT_MAPPING"] = "DIRECT_MAPPING";
    BackupZeroEtlSingleResourceTableMappingMode["BACKUP_ZERO_ETL_SINGLE_RESOURCE_TABLE_MAPPING_MODE_MERGE_DATABASES"] = "MERGE_DATABASES";
})(BackupZeroEtlSingleResourceTableMappingMode || (BackupZeroEtlSingleResourceTableMappingMode = {}));
